import { WarningFilled } from '@ant-design/icons'
import { Tag, Typography } from 'antd'
import dayjs from 'dayjs'
import { useMemo } from 'react'

interface ActivationWarningProps {
  activationDate: dayjs.Dayjs | null
}

export const ActivationWarning: React.FC<ActivationWarningProps> = ({ activationDate }) => {
  const show = useMemo(() => {
    if (!activationDate) return false
    const today = dayjs()
    return today.isBefore(activationDate, 'day')
  }, [activationDate])

  if (!show) return null

  return (
    <Tag className='tag-item' icon={<WarningFilled style={{ fontSize: '18px' }} />} color='warning'>
      <Typography.Text style={{ fontSize: '14px', fontWeight: 600 }}>
        {`*** Scheduled for Activation: ${dayjs(activationDate).format('MM/DD/YYYY')} ***`}
      </Typography.Text>
    </Tag>
  )
}
